// src/App.jsx
import React from "react";
import PageHeader from "./components/PageHeader";
import SectionGroup from "./components/SectionGroup";
import sectionsData from "./data/sectionsData";
import "./App.css";

const App = () => {
    return (
        <div className="app-container">
            {/* 页头 */}
            <PageHeader />

            {/* 主内容区域 */}
            <main className="main-content" id="services">
                {sectionsData.map((section, index) => (
                    <SectionGroup
                        key={index}
                        category={section.category}
                        items={section.items}
                    />
                ))}
            </main>

            {/* 底部示例 */}
            <footer className="footer">
                <p>Copyright © 2023 - 2025 云上空地（宁波）科技有限公司 版权所有 inesight All Rights Reserved.</p>
                <p><a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">网站备案号：浙ICP备2023034953号-3</a></p>
                <p>公安备案:浙公网安备33022602000645号</p>
                <p>本解决方案与武汉屺郁科技有限公司共建并提供解决方案支撑，鸣谢武汉屺郁科技有限公司给我们的帮助和支持。</p>
                <p>需要帮助吗？拨打热线：17671677467</p>
            </footer>
        </div>
    );
};

export default App;
